<script>
import { defineComponent, computed } from 'vue'

import StaticImage from '@/atoms/StaticImage.vue'

import purpleBg from '@/assets/bg-images/bg-purple.js'
import goldBg from '@/assets/bg-images/bg-gold.js'

export default defineComponent({
  name: 'SectionBg',
  components: {
    StaticImage
  },
  props: {
    theme: { type: String, default: 'purple' }
  },
  setup (props, { attrs, slots, emit }) {
    const bg = computed(() => {
      switch (props.theme) {
        case 'purple':
          return purpleBg
        case 'gold':
          return goldBg
        default:
          return purpleBg
      }
    })

    const gradient = computed(() => {
      switch (props.theme) {
        case 'gold':
          return true
        default:
          return false
      }
    })

    return {
      bg,
      gradient
    }
  }
})
</script>

<template>
  <StaticImage
    cover
    class="bg pointer-events-none !absolute top-0 left-0"
    :class="{ gradient }"
    :data="bg"
  />
</template>

<style lang="scss" scoped>
.bg {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0%) 58%, rgba(0, 0, 0, 40%) 100%);
  }

  &.gradient {
    &::after {
      z-index: 1;
      content: "";
    }
  }
}
</style>
